<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';

// events
const onPreloadError = (event: Event) => {
  event.preventDefault();
  console.error('onPreloadError', event);
  const url = new URL(window.location.href);
  url.searchParams.set('_v', Date.now().toString());
  /* eslint-disable lodash/prefer-lodash-method */
  window.location.replace(url.toString());
};

// hooks
onMounted(() => {
  window.addEventListener('vite:preloadError', onPreloadError);
});

onBeforeUnmount(() => {
  window.removeEventListener('vite:preloadError', onPreloadError);
});
</script>

<template>
  <RouterView />
</template>

<style scoped lang="scss"></style>
